"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _multipleDL = require("./multipleDL.styles");

var _index = require("../../svg/index");

var _Loading = require("../Loading/Loading");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = require("../Checkbox/Checkbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MultipleDL = function MultipleDL(_ref) {
  var items = _ref.items,
      label = _ref.label,
      helper = _ref.helper,
      err = _ref.err,
      searchable = _ref.searchable,
      onSelect = _ref.onSelect,
      onRemove = _ref.onRemove,
      size = _ref.size,
      loading = _ref.loading,
      selectedItems = _ref.selectedItems;
  var listItemsRef = (0, _react.useRef)();
  var wrapperRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      flag = _useState2[0],
      dispatchFlag = _useState2[1];

  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _multipleDL.useStyles)({
    size: size,
    err: err,
    flag: flag,
    searchable: searchable
  });

  function multipleSelected() {
    var length = selectedItems.length;

    if (length < 3) {
      return selectedItems.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.multiplePicked,
          key: index
        }, item.title);
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.multiplePicked
      }, selectedItems[0].title), /*#__PURE__*/_react["default"].createElement("div", null, "..."), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.multiplePicked
      }, selectedItems[length - 1].title));
    }
  }

  function multiplePicked(sts, obj) {
    if (sts) return onSelect(obj);else return onRemove(obj);
  }

  function isSelectValue(obj) {
    return selectedItems.filter(function (item) {
      return item.id === obj.id;
    }).length > 0;
  }

  function multipleListItems() {
    return items.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: index,
        className: classes.dLListItem,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
        onChange: function onChange(e) {
          return multiplePicked(e.target.checked, item);
        },
        size: "sm",
        label: item.title,
        checked: isSelectValue(item)
      }));
    });
  }

  function toggleList() {
    dispatchFlag(!flag);
  }

  function filterFunction(v) {
    var _iterator = _createForOfIteratorHelper(listItemsRef.current.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        var txtContent = value.textContent;

        if (txtContent.indexOf(v) > -1) {
          value.style.display = "";
        } else {
          value.style.display = "none";
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        dispatchFlag(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.dLWrapper,
    ref: wrapperRef
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: classes.dLHeader,
    type: "button",
    onClick: function onClick() {
      return toggleList();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.label
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.multipleBox
  }, multipleSelected()), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.angle
  }, _index.arrow)), flag && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.dlList,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, searchable && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.searchBox
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: classes.searchBar,
    placeholder: searchable[0],
    onChange: function onChange(e) {
      return filterFunction(e.target.value);
    },
    autoFocus: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.searchIcon
  }, _index.searchIcon)), loading ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.loading
  }, /*#__PURE__*/_react["default"].createElement(_Loading.Loading, null)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.scrollList,
    ref: listItemsRef
  }, multipleListItems())), helper && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.helper
  }, helper), err && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.err
  }, err));
};

MultipleDL.propTypes = {
  /** An array of items for show in the list */
  items: _propTypes["default"].array,

  /** An array of items for show in the list */
  selectedItems: _propTypes["default"].array,

  /** Drop list label */
  label: _propTypes["default"].string,

  /** Help text, Is displayed below the list */
  helper: _propTypes["default"].string,

  /** Error text , Is displayed below the list and change border color */
  err: _propTypes["default"].string,

  /** Flag for show filter input */
  searchable: _propTypes["default"].bool,

  /** Add item to selected list */
  onSelect: _propTypes["default"].func,

  /** Remove item from selected list */
  onRemove: _propTypes["default"].func,

  /** Change component size */
  size: _propTypes["default"].oneOf(["xs", "sm", "lg"]),

  /** Show loading */
  loading: _propTypes["default"].bool
};
MultipleDL.defaultProps = {
  items: [],
  label: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
  helper: "",
  err: "",
  searchable: false,
  onSelect: function onSelect() {},
  onRemove: function onRemove() {},
  size: "sm",
  loading: false
};

var _default = /*#__PURE__*/_react["default"].memo(MultipleDL);

exports["default"] = _default;